// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"f3aaeba9","140":"8788c54c","281":"442fb67c","530":"7b19e6cb","600":"bb6c2104","845":"40e8dd3f"}[chunkId] + ".css";
};